module.exports = __webpack_public_path__ + "img/kyc-successful.5033b3c3.webp";